import { useRef, useState } from 'react'; // ReactNode, SyntheticEvent

// material-ui
import { useTheme ,Theme} from '@mui/material/styles';
import { Box, ButtonBase, CardContent, ClickAwayListener, Grid2, Paper, Popper, Stack, Typography } from '@mui/material'; // Tab, Tabs,
import useMediaQuery from '@mui/material/useMediaQuery';
// project-imports
import ProfileTab from './ProfileTab';

import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';

import useAuth from 'hooks/useAuth';

// assets
import avatar1 from 'assets/images/users/avatar-6.png';
import avatar2 from 'assets/images/users/avatar-7.png';
import { FormattedMessage } from 'react-intl';

import { resetDeviceState } from 'store/reducers/deviceSlice';
import { useDispatch } from 'store';







// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const ProfilePage = () => {
  const theme = useTheme();
  const downSM = useMediaQuery((theme: Theme) => theme.breakpoints.down(666));
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down(1440));
  const dispatch = useDispatch();
  function capitalizeFirstLetter(str: any) {
    return str
      .split(' ')
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  const { logout, user,organization }: any = useAuth();
  const handleLogout = async () => {
    try {
      await logout();
      dispatch(resetDeviceState());
 
    } catch (err) {
      console.error(err);
    }
  };
  let name: string;
  let types: string;
 
  if (user?.firstName && user?.lastName && user?.type) {
    name =
      user?.firstName.charAt(0).toUpperCase() +
      user?.firstName.slice(1) +
      ' ' +
      user?.lastName.charAt(0).toUpperCase() +
      user?.lastName.slice(1);
    types = user?.type.charAt(0).toUpperCase() + user?.type.slice(1);
  }

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState<boolean>(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef?.current?.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  let boxRightMargin;
  if(user?.type === 'student'){
      boxRightMargin = downSM ? 0 : 2
  }
  else {
    boxRightMargin = 0
  }

  let avatarSrc;
  if(user?.userProfilePicId?.path){
    avatarSrc = process.env.REACT_APP_FILE_URL + user?.userProfilePicId?.path
  }
  else if(user?.userProfilePicId?.mimetype){
    avatarSrc = `data:${user?.userProfilePicId?.mimetype};base64,${user?.userProfilePicId?.file}`
  }
  else if(user && user.gender === 'female'){
    avatarSrc = avatar2
  }
  else {
    avatarSrc = avatar1
  }

 


  return (
    <Box sx={{ flexShrink: 0, ml: user?.type === 'student' ? 0 : 0.75, mr: boxRightMargin }}>
      <Stack direction="row" spacing={1.25} alignItems="center">
        <ButtonBase
          sx={{
            p: 0.25,
            borderRadius: '50%',
            
            '&:focus-visible': {
              outline: `2px solid ${theme.palette.secondary.dark}`,
              outlineOffset: 2
            }
          }}
          className="profile"
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? 'profile-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
    

          <Avatar
            alt={user?.firstName}
            src={
                   avatarSrc
            }
            sx={{
              width: 45,
              height: 45,
              objectFit: 'contain',
              border: '1px solid',
              borderColor: theme.palette.primary.main,
              bgcolor: 'transparent',
              pointerEvents: 'none',
              userSelect: 'none'
            }}
          />
        </ButtonBase>
        {!downSM && user?.type === 'student' && (
          <Stack direction="column" display={'flex'} alignItems={'flex-start'}>
            <Typography
              onClick={handleToggle}
              sx={{
                fontSize: '14px',
                fontWeight: '600',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {name?.length > 20 ? `${name.slice(0, 20)}...` : name}
            </Typography>
            {organization?.ncvetCompliance === false &&
            <Typography sx={{ fontSize: '12px', fontWeight: '400' }}>
              {capitalizeFirstLetter(user?.type)} |{' '}
              {(user.classRoomId?.[0]?.className?.length > (user?.classRoomId?.[0]?.classType === 'other' ? 20 : 10) ? user?.classRoomId?.[0]?.className.slice(0, (user?.classRoomId?.[0]?.classType === 'other' ? 20 : 10)) + '...' : user?.classRoomId?.[0]?.className) +
                (user.classRoomId?.[0]?.semester ? `, sem ${user.classRoomId?.[0]?.semester}` : '') +
                (user.classRoomId?.[0]?.divisionName ? ` ${user.classRoomId?.[0]?.divisionName}` : '')}
            </Typography>}
          </Stack>
        )}
      </Stack>

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        sx={{
          zIndex: 1,
          transform: !downSM ? 'translate(-64%, 70px) !important' : 'translate(-5%, 70px) !important',
          maxWidth: !downLG && user?.type === 'student' ? '230px' : '290px'
        }}
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions position="top-right" in={open} {...TransitionProps}>
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                
                maxWidth: 290,
                [theme.breakpoints.down('md')]: {
                  maxWidth: 250
                },
                borderRadius: 1.5
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} content={false}>
                  <CardContent sx={{ px: 2, pt: 2, pb: 1 }}>
                    <Box
                      sx={{
                        border: `1px solid ${theme.palette.divider}`,
                        '&:hover': {
                          bgcolor: 'primary.lighter',
                          borderColor: theme.palette.primary.light
                        },
                        borderRadius: 2,
                        p: 2
                      }}
                    >
                      <Grid2 container justifyContent="space-between" alignItems="center">
                        <Grid2>
                          <Stack direction="row" spacing={1.25} alignItems="center">
                            <Avatar
                              alt={name}
                              src={
                                avatarSrc
                              }
                              sx={{
                                objectFit: 'contain',
                                border: '1px solid',
                                borderColor: theme.palette.primary.main,
                                bgcolor: 'transparent',
                                pointerEvents: 'none',
                                userSelect: 'none'
                              }}
                            />
                            <Stack direction="column">
                              
                              <Typography variant="h6" sx={{ fontWeight: '600' }}>
                                {name}
                              </Typography>
                              <Typography variant="caption" sx={{ fontWeight: '600' }}>
                                {types}
                              </Typography>

                              {user?.type === 'student' && organization?.ncvetCompliance === false && (
                                <Typography variant="body2">
                                  <FormattedMessage id="Points" />:{user?.points}
                                </Typography>
                              )}
                            </Stack>
                          </Stack>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </CardContent>

              
              
                  <ProfileTab handleLogout={handleLogout} setOpen={handleToggle} />
                  
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default ProfilePage;
